'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formatDateTime = exports.formatShortDateTime = exports.formatDateTimeWithShortDateTime = exports.formatDateTimeWithLongDateTime = exports.dateTimeFormat = exports.getDateTime = undefined;

var _momentTimezone = require('moment-timezone');

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

var _curry = require('lodash/curry');

var _curry2 = _interopRequireDefault(_curry);

var _dateTimeFormatter = require('@active/react-ui/shared/dateTimeFormatter');

var _dateTimeFormatter2 = _interopRequireDefault(_dateTimeFormatter);

var _DateTimeSymbols = require('@active/react-ui/form/config/DateTimeSymbols');

var DateTimeSymbols = _interopRequireWildcard(_DateTimeSymbols);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getDateTime = exports.getDateTime = function getDateTime(utcDateTime, eventTimeZone) {
  var dateTime = _momentTimezone2.default.utc(utcDateTime).tz(eventTimeZone);
  var fullDateTime = dateTime.format();
  var offset = dateTime.format('Z');
  var index = fullDateTime.indexOf(offset);

  if (index < 0) {
    return fullDateTime.replace(/Z/gi, '');
  }

  return fullDateTime.substring(0, index).replace(/Z/gi, '');
};

var getConfig = function getConfig(locale) {
  return DateTimeSymbols[locale] ? DateTimeSymbols[locale] : DateTimeSymbols.en_US;
};

var dateTimeFormat = exports.dateTimeFormat = (0, _curry2.default)(function (locale, timeZone, date, format) {
  var formatter = (0, _dateTimeFormatter2.default)(getConfig(locale));
  var targetZoneTime = _momentTimezone2.default.utc(date).tz(timeZone);

  return formatter(format, new Date(targetZoneTime.year(), targetZoneTime.month(), targetZoneTime.date(), targetZoneTime.hours(), targetZoneTime.minutes(), targetZoneTime.seconds(), targetZoneTime.milliseconds()));
});

var formatDateTimeWithLongDateTime = exports.formatDateTimeWithLongDateTime = (0, _curry2.default)(function (locale, timeZone, date) {
  return dateTimeFormat(locale, timeZone, date, getConfig(locale).FORMAT.LONG_DATETIME);
});

var formatDateTimeWithShortDateTime = exports.formatDateTimeWithShortDateTime = (0, _curry2.default)(function (locale, timeZone, date) {
  return dateTimeFormat(locale, timeZone, date, getConfig(locale).FORMAT.SHORT_DATETIME);
});

var formatShortDateTime = exports.formatShortDateTime = (0, _curry2.default)(function (locale, timeZone, date) {
  return dateTimeFormat(locale, timeZone, date, getConfig(locale).FORMAT.MONTH_ABBR_DATE);
});

var formatDateTime = exports.formatDateTime = (0, _curry2.default)(function (locale, timeZone, date) {
  return dateTimeFormat(locale, timeZone, date, getConfig(locale).FORMAT.LONG_DATE);
});

exports.default = formatDateTime;